import { ColumnDef } from '@tanstack/react-table';
import * as React from 'react';
import { Link } from "react-router-dom";
import { useFetchOperation } from '../../service/Operation';
import { User } from '../../types/Common';
import { LocalDateTime } from '../formatters/DateTimeFormat';
import AutoPaginationTable from '../general/AutoPaginationTable';
import Error from '../general/Error';
import Loader from '../general/Loader';

export default function UserList() {
    const [users, setUsers] = React.useState<User[]>();

    const [getting, startGetting] = useFetchOperation(setUsers, undefined, true);

    React.useEffect(() => {
        startGetting('get', `api/user/all`);
        document.title = `All users - ${(document as any).rootTitle}`;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <h1 className='mb-3'>All users</h1>
            {getting.active ?
                <Loader />
                :
                !users?.length ?
                    <Error text={getting.error} />
                    :
                    <AutoPaginationTable
                        columns={columns}
                        data={users} />
            }
        </>
    )
}

const columns: ColumnDef<User>[] = [
    {
        header: 'Id',
        accessorFn: x => x.id,
        cell: props => <Link to={`/user/${props.row.original.id}`}>{props.row.original.id}</Link>
    },
    {
        header: 'Username',
        accessorFn: x => x.userName,
    },
    {
        header: 'Email',
        accessorFn: x => x.email,
    },
    {
        header: 'Email confirmed',
        accessorFn: x => x.emailConfirmed,
        cell: props => <span>{props.row.original.emailConfirmed ? '✓' : '-'}</span>
    },
    {
        header: 'UI language',
        accessorFn: x => x.language,
    },
    {
        header: 'Mode for studying',
        accessorFn: x => x.currentModes,
        cell: props =>
            <span>{props.row.original.currentModes?.map((mode, i) =>
                <span key={i}>{i === 0 ? '' : ', '}<Link to={`/dictionaries/${mode.dictionaryId}`}>{mode.dictionaryName}</Link>{mode.isDirect ? '' : ' (inv.)'}</span>)}
                {props.row.original.mixedModesLimit ? ', mix lim.' : ''}
            </span>
    },
    {
        header: 'Role',
        accessorFn: x => x.role,
        cell: props => <Link to={`/user/${props.row.original.id}/role`}>{props.row.original.role}</Link>
    },
    {
        header: 'Last activity',
        accessorFn: x => x.lastActivity,
        cell: props => <LocalDateTime value={props.row.original.lastActivity} />
    },
];
